import SelectionChange from '@models/betSlip/SelectionChange';
import { map as _map } from '@lodash';
import StoreUtil from '@store/StoreUtil';
import IBetSlipState from '../types';

export default {
    changes(state: IBetSlipState): SelectionChange[] {
        return _map(state.changes, (change) => change);
    },
    autoUpdateChanges: StoreUtil.createSimpleGetter('autoUpdateChanges'),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/shared/betSlip/getters/changes.ts